import request from './request';

export const fetchUserJournals = () =>
  request({
    method: 'GET',
    url: '/clients/journals',
    protectedRoute: true,
    newApi: true
  });

export const fetchJournals = () =>
  request({
    method: 'GET',
    url: '/api/v1/journals/?no_page&division=1',
    protectedRoute: true,
    newApi: false
  });

export const updateUserJournals = (data) =>
  request({
    method: 'PATCH',
    url: `/api/v1/clients/me/journals/${data.id}/`,
    data,
    protectedRoute: true,
    newApi: false
  });

export const removeUserJournals = (id) =>
  request({
    method: 'DELETE',
    url: `/api/v1/clients/me/journals/${id}/`,
    protectedRoute: true,
    newApi: false
  });

export const createUserJournals = (data) =>
  request({
    method: 'POST',
    data,
    url: `/api/v1/clients/me/journals/`,
    protectedRoute: true,
    newApi: false
  });
